import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import * as _ from 'lodash';
import { BalancesService } from 'src/app/shared/services/balances.service';
import { Router } from '@angular/router';
import { Level } from '../../shared/enums/level.enum';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss']
})
export class RequestsComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  dispersions: Dispersion[];
  popupVisible: boolean = false;
  selectedDispersion = null;
  currentTemplate: string = 'aprove';
  balanceObj: any;
  dispersionAmount = null;
  usdt: any;
  id_companies_list: any[]=[];
  dispersionId:string;

  constructor(
    private router: Router,
    private dispersionsService: DispersionsService,
    private utilitiesService: UtilitiesService,
    private balancesService: BalancesService,
  ) {
    this.usdt = this.utilitiesService.getUserData();

    switch (this.usdt.level) {
      case Level.ihunterSuperUser:
      case Level.ihunterAdmin:
        this._subscriptions.push(
          this.dispersionsService.getDispersions().subscribe(dispersions => {
            this.dispersions = dispersions;
          })
        );
      break;
      case Level.Broker:
        if (this.usdt.companyList) {
          this.usdt.companyList.forEach(company => {
            this.id_companies_list.push(company.id.trim());
          });
        }
        this._subscriptions.push(
          this.dispersionsService.getDispersions().subscribe(dispersions => {
            this.dispersions = dispersions.filter(dispersion => this.id_companies_list.includes(dispersion.companyId));
          })
        );
      break;
      default:
      break;
    }
  }

  ngOnInit() {
  }

  aproveDispersion(id) {
    // console.log(id);
    const dispersionId = id;
    this.dispersionId =id;
    const dispObj = _.filter(this.dispersions, ['id', dispersionId]);
    this.dispersionAmount = dispObj[0].granTotal;
    const companyId = dispObj[0].companyId;
    // console.log('companyId', companyId);
    this._subscriptions.push(
      this.balancesService.getCompanyBalance(companyId).subscribe(balance => {
        this.balanceObj = balance[0];
        console.log('this.balanceObj.balance', this.balanceObj.balance, 'this.dispersionAmount', this.dispersionAmount);
        console.log('Montos : ', this.balanceObj.balance , this.dispersionAmount);
        this.currentTemplate = 'aprove';
        /*if (this.balanceObj.balance < this.dispersionAmount) {
          this.currentTemplate = 'notEnoughBalance';
        } else {
          this.currentTemplate = 'aprove';
        }*/
      })
    );
    // console.log(dispObj[0], this.balanceObj);
    this.selectedDispersion = id;
    this.popupVisible = true;
  }

  disaproveDispersion(id) {
    // console.log(id);
    this.currentTemplate = 'cancel';
    this.selectedDispersion = id;
    this.popupVisible = true;
  }

  async confirmDispersion() {
    try {
      const data = { status: 2 };
      await this.dispersionsService.updateDispersion(this.selectedDispersion, data)
      .then(data => {
        console.log(data);
        this.popupVisible = false;
        notify('Dispersion Aprobada con éxito','success',3000);
      })
      .catch(error => error);

      await this.utilitiesService.executeDispersion(this.dispersionId).toPromise()
      .then(data => {
        console.log(data);
        if(!data.error) {
          notify('Dispersion Ejecutada con éxito','success',3000);
        } else {
          throw data;
        }
      })
      .catch(error => {
        console.log(error);
        notify(error.message ? error.message :'Ocurrio un problema al intentar ejecutar la Dispersion','error',2000);
      });
    } catch(err) {
      console.log(err);
    } 
    
    
    
  }
  confirmDisaprobalOfDispersion() {
    const data = { status: 1 };
    this.dispersionsService.updateDispersion(this.selectedDispersion, data).then(data => {
      this.popupVisible = false;
      this.utilitiesService.notifyMe('Dispersión desaprobada', 'success');
    }).catch(error => console.log(error)
    );
  }


  cancelDispersion() {
    this.popupVisible = false;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
  viewDetail(id) {
    this.router.navigate(['/dash/dispersions/' + id]);
  }
}
